import './ImportingGuidelines.scss';
import { defineComponent, h } from 'vue';

const guidelines = `<p>For successful conversions, please keep in mind the current limitations:</p>

<section>
    <h4>Disconnected loops</h4>

    <p>Phi currently requires the boundaries of each face to be connected. This means that, in case there are disconnected loops, as in the video below, Phi will fail to load the faces that contain them, and give a relevant warning.</p>

    <p><b>Troubleshooting:</b> Faces that contain such "disconnected loops" can be appropriately <b>split</b> in the Part Studio, and then imported into Phi.</p>

    <div class='vimeo-embed'>
        <iframe src="https://player.vimeo.com/video/776920640?loop=1&title=0&byline=0&portrait=0"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen>
        </iframe>
    </div>
</section>

<section>
    <h4>Concave faces</h4>
    <p>Concave faces might cause surfaces to fold.</p>
    <p><b>Troubleshooting:</b> In case this happens, simply <b>add an edge</b> to the reflex angles, as shown below:</p>

    <div class='vimeo-embed'>
        <iframe src="https://player.vimeo.com/video/776980842?loop=1&title=0&byline=0&portrait=0"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen>
        </iframe>
    </div>
</section>

<section>
    <h4>Short edges</h4>
    <p>Fillets sometimes create faces that are too small (relatively to the entire body) to be processed.</p>
    <p><b>Troubleshooting:</b> The quickest way to overcome this is to <b>suppress</b> the fillet that causes the issue, and import again.</p>
</section>

<section>
    <h4>Automatically handled by Phi</h4>
    <p>Sometimes, Phi will automatically make minor changes to your models in order to successfully import them. You will be notified about these changes.</p>
</section>
`;

export default defineComponent({
    render() {
        return h('div', {
            class: 'importing-guidelines',
            innerHTML: guidelines,
            style: {
                'text-align': 'left'
            }
        });
    }
});
